export default __webpack_public_path__ + "static/media/recommend-icon.7e508b2a.svg";